import { AmenitiesList } from '@/components/amenities';
import { PageContainer } from '@startupquickstart/frontend';

/**
 * Amenities list page
 */
export function AmenitiesPage() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Amenities', current: true },
  ];

  return (
    <PageContainer>
      <AmenitiesList breadcrumbs={breadcrumbs} />
    </PageContainer>
  );
}
